var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsxs as _jsxs } from "@emotion/react/jsx-runtime";
/**
 * Copyright 2019, SumUp Ltd.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { css } from '@emotion/react';
import Body from '../../../Body';
import { typography } from '../../../../styles/style-mixins';
const textStyles = ({ theme }) => css `
  ${theme.mq.untilKilo} {
    ${typography('two')(theme)};
  }
`;
const StyledText = styled(Body)(textStyles);
const Status = (_a) => {
    var { step, total } = _a, props = __rest(_a, ["step", "total"]);
    return (_jsxs(StyledText, Object.assign({ variant: "highlight" }, props, { children: [step + 1, " / ", total] })));
};
Status.propTypes = {
    /**
     * Current active index of a carousel.
     */
    step: PropTypes.number,
    /**
     * Total number of slides in a carousel.
     */
    total: PropTypes.number,
};
Status.defaultProps = {
    step: 0,
    total: 0,
};
export default Status;
